import $ from 'jquery';

import { LazyLoad } from 'Util/lazyload';
import { QueryString } from 'Util/querystring';
import { LazyBackground } from 'Util/lazybg';

import { NavLoad } from 'App/nav/load';
import { TrackLoad } from 'App/track/load';
import { Rotator } from 'App/rotator/rotator';
import { RotatorFlickity } from 'App/rotator/rotator-flickity';
import { Accordion } from 'App/accordion/accordion';
import { VideoPlayer } from 'App/video/video.player';
import { SocialShare } from 'App/social/share';
import { MapLoad } from 'App/map/map.load';
import { UmbracoForms } from 'App/form/form.umbraco';
import { Tooltip } from 'App/tooltip/tooltip';
import { AjaxReplace } from 'App/ajaxreplace/ajaxreplace';
import { Ticker } from 'App/ticker/ticker';
import { Cookie } from 'App/cookie/cookie';
import { ExpandCollapse } from 'App/expand-collapse/expand-collapse';
import { AjaxForm } from 'App/form/ajax';
import { VideoLoad } from 'App/video/load';
//import { ListingMasonry } from 'App/listing/masonry';
import { InfiniteScroll } from 'App/infinitescroll/infinitescroll';
import { throttle } from 'Util/throttle';
import { publish, unpublish, subscribe } from 'Util/pubsub';

import moment from 'moment';
import Pikaday from 'pikaday';

import 'autocomplete';
import 'phatfingaz';
import 'throttledebounce';
import 'tablescroll';
import 'magnificPopup';
import 'equalHeaders';
import 'unobtrusiveAjax';

TrackLoad.init();
NavLoad.init();
LazyLoad.init();
Tooltip.init();
AjaxReplace.init();
SocialShare.init();
Cookie.init();
ExpandCollapse.init();
AjaxForm.init();
UmbracoForms.init();
VideoLoad.init();
VideoPlayer.init();
//ListingMasonry.init();
InfiniteScroll.init();
Accordion.init();

// Publish Resize event
var publishResizeEvent = function () {
	publish('/window/resize');
};

var publishScrollEvent = function () {
	publish('/window/scroll');
};

$('.js-hot').phatFingaz();

var $courseAutocomplete = $('.js-course-finder');
if ($courseAutocomplete.length) {

	$.ajax({
		url: '/CrmData/course/getlist',
		success: function (response) {

			$courseAutocomplete.autocomplete({
				source: response,
				mapToFilteredValue: function (a) {
					return a.ProductId;
				},
				mapToDisplayText: function (a) {
					return a.Name;
				},
				clickCallback: function ($option, obj) {
					$('#eventSearchCourse').val(obj.ProductId);
				}
			});
		}
	});
}

// Rotators
var $lazybg = $('.js-lazy-bg');
if ($lazybg.length) {
	LazyBackground.init($lazybg);
}

// Maps
var $maps = $('.js-map');
if ($maps.length) {
	MapLoad.init($maps);
}

// Rotators
var $rotators = $('.js-rotator');
if ($rotators.length) {
	Rotator.init($rotators);
}

// Flickity Rotators
var $flickityRotators = $('.js-rotator-flickity');
if ($flickityRotators.length) {
	RotatorFlickity.init($flickityRotators);
}

//Ticker
var $ticker = $('.js-statistics');
if ($ticker.length) {
	Ticker.init();
}

var $window = $(window);

$window.on('resize', throttle(250, publishResizeEvent));
$window.on('scroll', publishScrollEvent);

// Check DOM for elements requiring JS
var $tables = $('.c-rte').find('table').filter(':visible');

// Table Scroll
if ($tables.length) {
	$tables.tableScroll();
}

var lightboxSingle = $('.js-lightbox-single');
if (lightboxSingle.length) {
	// Single and Multi Image Lightbox
	$('.js-lightbox-single').magnificPopup({
		delegate: '.js-lightbox-image',
		type: 'image'
	});
}

var lightboxDouble = $('.js-lightbox-gallery');
if (lightboxDouble.length) {
	$('.js-lightbox-gallery').each(function () {
		$(this).magnificPopup({
			delegate: '.js-lightbox-image',
			type: 'image',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
			}
		});
	});
}

// related courses
var $relatedCourses = $('.c-related-courses');
if ($relatedCourses.length) {
	$relatedCourses.equalHeaders({
		headerClass: '.c-event-item__heading'
	});
}

var $DatePicker = $('.js-datepicker');

if ($DatePicker.length) {
	$DatePicker.each(function () {
		var datepicker = new Pikaday(
			{
				field: $(this)[0],
				firstDay: 1,
				minDate: new Date(),
				maxDate: new Date('31-12-2025'),
				yearRange: [2000, 2025],
				container: $(this).parent()[0],
				format: 'DD/MM/YYYY',
				onSelect: function () {
					var date = moment(datepicker.toString(), 'DD/MM/YYYY').format('DD/MM/YYYY');
					$(this).attr('data-date', date);
					$(this).val(moment(datepicker.toString(), 'DD/MM/YYYY').format('DD/MM/YYYY'));
				}
			});
	});
}

// Jira Ticket: SNA-182
var bookingFormSpacesRequiredGUID = 'd78d4817-79ff-44fb-8744-c168b15574d6';
var $spacesRequired = $('[name="' + bookingFormSpacesRequiredGUID + '"]');
var $options = $spacesRequired.find('option');
var querystring = QueryString.get();

if ($spacesRequired.length && querystring.spacesAvailable) {
	$options.filter(function (i, el) {
		var $el = $(el);
		var val = parseInt($el.val(), 10);
		return val && (val > parseInt(querystring.spacesAvailable, 10));
	}).hide();
}

var $events = $('.c-listing-events');
if ($events.length) {
	$events.equalHeaders({
		headerClass: '.c-event-item__heading'
	});
}